// Pure helpers for the recommendation elements. Framework-free so `node --test` can cover them.

function parseObject(input) {
  if (input && typeof input === 'object' && !Array.isArray(input)) return { ...input }
  if (typeof input !== 'string' || input.trim() === '') return {}

  try {
    const parsed = JSON.parse(input)
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch {
    return {}
  }
}

/** Liquid emits every setting as a string; Flickity needs a boolean or a number. */
export function coerceGroupCells(value) {
  if (value === 'true') return true
  if (value === 'false') return false
  if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(Number(value))) return Number(value)
  return value
}

export function parseCarouselSettings(input) {
  const settings = parseObject(input)
  if (settings.groupCells !== undefined) settings.groupCells = coerceGroupCells(settings.groupCells)
  return settings
}

export function parseCardSettings(input) {
  return parseObject(input)
}

export function cartProductIds(items) {
  if (!Array.isArray(items)) return ''

  const ids = items
    .map((item) => item?.product_id)
    .filter(Boolean)
    .map(String)

  return [...new Set(ids)].join(',')
}
